<template>
  <v-dialog
    v-model="loginDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card color="basil">
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title class="text-center justify-center py-6">
        <h1 class="font-weight-bold display-3 basil--text">登录</h1>
      </v-card-title>
      <v-tabs
        v-model="loginTab"
        background-color="transparent"
        color="basil"
        grow
      >
        <v-tab key="验证码登录"> 验证码登录</v-tab>
        <v-tab key="账号登录"> 账号登录</v-tab>
      </v-tabs>

      <v-tabs-items v-model="loginTab">
        <v-tab-item key="验证码登录">
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="mdi-phone"
                label="手机号*"
                required
                v-model="phone"
              ></v-text-field>
              <v-text-field
                prepend-icon="mdi-lock"
                label="验证码*"
                v-model="code"
                required
                ><v-btn slot="append" @click="sendCode" :disabled="sending">{{codeButton}}</v-btn></v-text-field
              >
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="pink" @click="loginByCode">登录</v-btn>
          </v-card-actions>
        </v-tab-item>
        <v-tab-item key="账号登录">
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="mdi-phone"
                label="手机号*"
                required
                v-model="phone1"
              ></v-text-field>
              <v-text-field
                prepend-icon="mdi-lock"
                label="密码*"
                type="password"
                required
                v-model="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="pink" @click="loginByPasswd">登录</v-btn>
          </v-card-actions>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-snackbar
      timeout="1500"
      absolute
      top
      style="text-align:center"
      color="#c56060"
      v-model="snackbar"
    >
        {{snackInfo}}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import * as login from '@/api/index'
export default {
    name: 'Login',
    props: ['loginDialog'],
    data () {
        return {
            loginTab: '',
            sending: false,
            codeButton: '发送验证码',
            phone: null,
            phone1: null,
            code: '',
            password: '',
            snackbar: false,
            snackInfo: '登录错误，请稍后再试'
        }
    },
    methods: {
       sendCode() {
         if (this.sending) {
           return
         }
        login.sendCode({mobile: this.phone})
          .then(() => {
            this.sending = true
            let n = 60
            this.codeButton = n
            const timer = setInterval(() => {
              if (n < 1) {
                clearInterval(timer)
                this.codeButton = '发送验证码'
                this.sending = false
                return
              }
              this.codeButton = --n
            }, 1000);
          })
          .catch(err => {
              this.snackbar = true
              this.snackInfo = err.msg
          })
      },
      async loginByCode() {
        const {phone, code: password} = this
        await login.loginByCode({username: phone, password, type: 'code'})
            .then(res => {
              this.loginSucc(res)
            })
            .catch(err => {
              this.loginFail(err)
            })
      },
      async loginByPasswd() {
        const {phone1: phone, password} = this
        await login.loginByPasswd({username: phone, password, type: 'passwd'})
          .then(data => {
             this.loginSucc(data)
            })
          .catch(res => {
              this.loginFail(res)
            })
      },
      loginSucc(data) {
        console.log({data})
        localStorage.setItem('token', data.token)
        localStorage.setItem('role_name', data.role_name)
        if (data.role_name) {
          localStorage.setItem('status', 'login')
          this.$emit('loginSucc')
        } else {
          localStorage.setItem('status', 'select_role')
          this.$emit('selectRole', data.role_list)
        }
        
      },
      loginFail(res) {
          this.snackbar = true
          this.snackInfo = res.code === 50000 ? '登录失败' : '登录错误，请稍后再试'
          console.log(res)
      }
    }
};
</script>

<style>
</style>